/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Status planu w wierszu listy (kubełek liczony względem aktywnego cyklu).
 * @export
 * @enum {string}
 */

export const TeamPlanStatusDto = {
    Approved: 'APPROVED',
    Waiting: 'WAITING',
    Overdue: 'OVERDUE',
    Draft: 'DRAFT',
    None: 'NONE'
} as const;

export type TeamPlanStatusDto = typeof TeamPlanStatusDto[keyof typeof TeamPlanStatusDto];



